import './style.scss';
import Gravity from 'Gravity';
import YouTubePlayer from './providers/YouTubePlayer';
import VimeoPlayer from './providers/VimeoPlayer';
import WistiaPlayer from './providers/WistiaPlayer';

class VideoLightbox {
    constructor(element) {
        this.block = element;
        this.playButton = element.querySelector('.gravity-block-external-video__play-button');
        this.container = element.querySelector('.gravity-block-external-video__lightbox-container');
        this.modal = element.querySelector('.gravity-block-external-video__lightbox-modal');
        this.playerBox = element.querySelector('.gravity-block-external-video__player');
        this.closeButton = element.querySelector('.gravity-block-external-video__lightbox-close');
        this.overlay = element.querySelector('.gravity-block-external-video__lightbox-overlay');
        this.content = element.querySelector('.gravity-block-external-video__content-wrapper');
        this.videoId = element.dataset.videoId || '';
        this.isLightBox = element.dataset.isLightbox || false;
        this.provider = element.dataset.provider;
        this.trapFocusHandler = Gravity.trapFocusHandler(this.modal);
        this.videoIconPlay = element.querySelector('.gravity-block-external-video__icon');
        this.videoOverlay = element.querySelector('.gravity-block-external-video__thumbnail-wrapper');
        this.videoShow = element.querySelector('.gravity-block-external-video--modal-show');
        this.player = {};
    }

    init() {
        this.createPlayerProvider();
        this.addPlayButtonEvents();

        if (this.isLightBox) {
            this.addLightboxEvents();
        }

        this.initEscHandler();
    }

    createPlayerProvider() {
        switch (this.provider) {
            case 'youtube':
                this.player = new YouTubePlayer(this.videoId, this.playerBox);
                break;
            case 'vimeo':
                this.player = new VimeoPlayer(this.videoId, this.playerBox);
                break;
            case 'wistia':
                this.player = new WistiaPlayer(this.videoId, this.playerBox);
                break;
            default:
                throw new Error('Undefined provider');
        }
    }

    addLightboxEvents() {
        if (this.overlay && this.closeButton) {
            [this.overlay, this.closeButton].forEach((item) => {
                item.addEventListener('click', () => {
                    this.player.pause();
                    this.lightboxHide();
                });
            });
        }
    }

    addPlayButtonEvents() {
        this.playButton?.addEventListener('click', (e) => {
            e.preventDefault();

            this.player.createPlayerBox();

            if (this.isLightBox) {
                this.playButton.classList.add('gravity-block-external-video__lightbox-play-button--disable');
                this.lightboxShow();
                this.player.play();
            } else {
                this.player.play();
                this.hideOverlay();
            }
        });
    }

    lightboxShow() {
        document.body.classList.add('overflow-hidden');
        this.block.classList.add('gravity-block-external-video--modal-show');
        this.videoShow = true;
        document.addEventListener('focus', this.trapFocusHandler, true);
    }

    lightboxHide() {
        document.removeEventListener('focus', this.trapFocusHandler, true);
        document.body.classList.remove('overflow-hidden');
        this.block.classList.remove('gravity-block-external-video--modal-show');
        this.playButton.classList.remove('gravity-block-external-video__play-button--disable');
        this.videoShow = false;
    }

    hideOverlay() {
        this.content?.classList.add('gravity-block-external-video__content-wrapper--hide');
        this.videoOverlay.classList.add('gravity-block-external-video__thumbnail-wrapper--hide');
        this.videoIconPlay?.classList.add('gravity-block-external-video__icon--scale');
    }

    initEscHandler() {
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' || event.keyCode === 27) {
                if (this.videoShow) {
                    if (this.closeButton) {
                        this.closeButton.click();
                    }
                }
            }
        });
    }
}

Gravity.ready(() => {
    document.querySelectorAll('.gravity-block-external-video').forEach((module) => {
        new VideoLightbox(module).init();
    });
});